import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconMessage.module.css';

const IconMessage = (props) => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
    >
      <title>Message</title>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M4 4h16v12H5.17L4 17.17V4zm0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 9h12v2H6zm0-3h12v2H6zm0-3h12v2H6z" />
    </svg>
  );
};

IconMessage.defaultProps = {
  rootClassName: null,
  className: null,
};

IconMessage.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconMessage;
